import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles';
import { InfoFontIcon, SubcriptionsFontIcon, SortIcon, DateRangeBlackIcon, ReNewIcon } from '../../components/CustomIcons';
import theme, { commonFont } from '../../theme.css';
import CustomSection from '../../components/CustomSection';
import { cyan } from '@mui/material/colors';
import { formatDateToDDMMYYYYFrEpoch } from '../../utils/commons';
import { dataUtil, usage_type } from '../../services/wsclients/dataUtil';

const useStyles = makeStyles((theme) => ({
    main: {
        padding: theme.spacing(2),
        background: theme.palette.common.white,
    },
    desc: {
        background: cyan['A400'],
        padding: theme.spacing(2, 1),
        borderRadius: theme.spacing(0.5),
        color: theme.palette.common.white,
        alignItems: 'center'
    },
    text_desc: {
        paddingLeft: theme.spacing(1),
    },
    //table: 
    cell: {
        fontFamily: commonFont.regular,
    },
    columnSeparator: {
        display: 'none!important'
    },
    box: {
        background: cyan['A400'],
        color: theme.palette.common.white,
        padding: theme.spacing(2, 3),
        borderRadius: theme.spacing(0.5)
    },
    link: {
        color: '#337ab7',
        padding: theme.spacing(1, 1)
    },
    section: {
        padding: theme.spacing(2, 1),
        borderRadius: theme.spacing(0.5),
        border: '1px solid #ccc'
    },
    info: {
        padding: theme.spacing(2)
    },
    button: {
        margin: theme.spacing(0, 0.5, 0.5, 0.5) + '!important',
    },
    text_services: {
        margin: theme.spacing(2, 0) + '!important',
        padding: theme.spacing(1)
    },
    paper_container: {
        backgroundColor: theme.palette.common.white + "!important",
    },
    list: {
        padding: theme.spacing(2, 0),
    },
    item: {
        border: '0px solid',
        borderColor: theme.palette.background.transparent,
        borderRadius: theme.spacing(2),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
        //height: 280,
        // backgroundColor: theme.palette.background.secondary,
        position: 'relative',
        padding: '15px 10px'
    },
    sub_img: {
        display: 'flex',
        alignItems: 'center'
    },
    item_cover: {
        border: '1px solid ' + theme.palette.border.secondary,
        borderRadius: theme.spacing(2),
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        marginLeft: theme.spacing(1),
        "& img": {
            width: theme.spacing(10),
            height: theme.spacing(10),
            padding: theme.spacing(0.5),
            objectFit: 'contain',
        }
    },
    status: {
        display: 'flex',
        alignItems: 'center',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    sub_date: {
        alignItems: 'center',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        // height: 100
    }
}));

export default function SubcriptionsView(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const { rows, providerOrder, periods, periodSelected, onChangeTab, subcriptions, currency, onTerminate } = props;
    console.log("subcriptions==", subcriptions);
    let isOpenserveContact = false;
    let isMetrofibreContact = false;
    if(providerOrder && providerOrder == 'openserve'){
        isOpenserveContact = true;
    } else if(providerOrder && providerOrder == 'metrofibre'){
        isMetrofibreContact = true
    }
       

    return (
        <Grid item xs={12} className={classes.main}>
            <CustomSection notMarginTop={true}
                title={t('menu_subcriptions')}
                icon={<SubcriptionsFontIcon style={{
                    color: theme.palette.common.white,
                }} />}
                customClass={classes.customClass}
            >
                <Grid item xs={12} container direction='row' className={classes.desc}>
                    <InfoFontIcon style={{
                        color: theme.palette.common.white,
                    }} />
                    <Typography variant='body2' className={classes.text_desc}>{t('subcriptiions_desc')}</Typography>
                </Grid>
                {/* <Grid item xs={12} marginTop={2} className={classes.section}>
                    <Typography variant='body2' className={classes.link}>{t('normal_plan') + ' (S0000000713)'}</Typography>
                    <Grid item xs={12} container direction='row' className={classes.info}>
                        <Grid item xs={12} sm={5}>
                            <Grid item xs={12} container direction='row'>
                                <Grid item xs={4}>
                                    <Typography variant='body2'>{t('sub_name')}</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography variant='body1'>{t('Normal Subscription Plan')}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container direction='row'>
                                <Grid item xs={4}>
                                    <Typography variant='body2'>{t('sub_description')}</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography variant='body1'>{t('Prepaid Month to Month Subscription')}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container direction='row'>
                                <Grid item xs={4}>
                                    <Typography variant='body2'>{t('first_active')}</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography variant='body1'>{t('19/11/2021')}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container direction='row'>
                                <Grid item xs={4}>
                                    <Typography variant='body2'>{t('sub_Date')}</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography variant='body1'>{t('')}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={5}>
                            <Grid item xs={12} container direction='row'>
                                <Grid item xs={4}>
                                    <Typography variant='body2'>{t('billing')}</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography variant='body1'>{t('Monthly')}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container direction='row'>
                                <Grid item xs={4}>
                                    <Typography variant='body2'>{t('frequency')}</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography variant='body1'>{t('')}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container direction='row'>
                                <Grid item xs={4}>
                                    <Typography variant='body2'>{t('sub_state')}</Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography variant='body1'>{t('EFFECTIVE')}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={2} container direction='row'>
                            <Button variant='contained' size='small'
                                className={classes.button}
                                onClick={() => props.onSwarpService()}
                                startIcon={<SortIcon />}
                            >
                                {t('btn_upgrade_downgrade')}
                            </Button>
                            <Button variant='contained' size='small'
                                className={classes.button}
                                onClick={() => props.onTerminate()}
                                startIcon={<SortIcon />}
                            >
                                {t('btn_terminate')}
                            </Button>
                        </Grid>
                    </Grid>
                    <Typography variant='body2' className={classes.text_services}>{t('services')}</Typography>
                    <CustomTable
                        showHeader={true}
                        rows={rows}
                        columns={columns}
                        columnAction={true}
                    />
                </Grid> */}
                <Grid item xs={12}>
                    <SubscriptionPreview
                        t={t}
                        classes={classes}
                        periods={periods}
                        periodSelected={periodSelected}
                        subcriptions={subcriptions}
                        currency={currency}
                        onChangeTab={onChangeTab}
                        onSwarpService={props.onSwarpService}
                        onTerminate={onTerminate}
                        onChangeBillingDay={props.onChangeBillingDay}
                        isOpenserveContact={isOpenserveContact}
                        onCancel={props.onCancel}
                        isMetrofibreContact={isMetrofibreContact}
                    />
                </Grid>
            </CustomSection>
        </Grid>
    );
}

function SubscriptionPreview(props) {
    const { classes, t, periods, periodSelected, isOpenserveContact, subcriptions, currency,isMetrofibreContact } = props;
    return (
        <Grid xs={12} item marginTop={2} padding={4} className={classes.section}>            
            {/* <Grid item xs={12} container alignItems='center'>
                {periods && periods.length > 0 && periods.map((period, index) => {
                    console.log("periodSelected == period: ", periodSelected === period);
                    return (
                        <Box key={index}>
                            <Button color={periodSelected === period ? 'primary' : 'info'} onClick={() => onChangeTab(period)}>
                                {period === 1 ? t('monthly') : period + t('month_title')}
                            </Button>
                        </Box>
                    );
                })}
            </Grid> */}
            <Grid xs={12} item className={classes.list}>
                {subcriptions && subcriptions.length > 0 &&
                    <Grid xs={12} item container className={classes.list}>
                        {subcriptions.map((item, idx) => (
                            <SubcriptionItem
                                key={idx}
                                t={t}
                                classes={classes}
                                item={item}
                                currency={currency}
                                onRecurringPayment={props.onRecurringPayment}
                                onSwarpService={props.onSwarpService}
                                onTerminate={props.onTerminate}
                                onChangeBillingDay={props.onChangeBillingDay}
                                isOpenserveContact={isOpenserveContact}
                                onCancel={props.onCancel}
                                isMetrofibreContact={isMetrofibreContact}
                            />
                        ))}
                    </Grid>
                }
            </Grid>
        </Grid>
    )
}

function SubcriptionItem(props) {
    const { classes, t, item, currency, isOpenserveContact,isMetrofibreContact } = props;
    console.log("AAA item sub===", item);
    let images = dataUtil.getImageByUsageType(item.service.product ? item.service.product.creatives : null, usage_type.product_item);
    let productType = item.service && item.service.product && item.service.product.type ?  item.service.product.type : null;
    // console.log("AAA image sub===", images);
    let imageSub = '/images/logo.png';
    if (images && images.length > 0) {
        imageSub = images[0].uri;
    }
    let showTerminate = true;
    let showChangeBillingDay = false;
    if(productType && productType.name === 'VC'){
        showTerminate = false;
        showChangeBillingDay = true;
    }
    return (
        <Grid xs={12} lg={4} item container className={classes.container}>
            <Grid xs={12} item className={classes.item}>
                <Grid item container style={{ alignItems: "center" }}>
                    <Grid item xs={9}>
                        <Grid item xs={12} className={classes.sub_img}>
                            <Grid item className={classes.item_cover}>
                                <img src={imageSub} alt="Image Service" />
                            </Grid>
                            <Typography variant='subtitle2' style={{ marginLeft: 10 }}>{item.service && item.service.product ? item.service.product.name : ""}</Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={3} style={{ textAlign: 'right' }}>
                        <Typography variant='subtitle2' style={{ marginLeft: 10 }}><strong>{currency}{item.service && item.service.product && item.service.product.price ? item.service.product.price.toFixed(2) : "0.00"}</strong></Typography>
                    </Grid>
                </Grid>
                <Grid item xs={12} className={classes.status}>
                    <Button size={"small"} variant='outlined'>{item.service.life_cycle_state}</Button>
                   {item.service.removed_on&& <Button sx={{ml:1}} size={"small"} variant='outlined'>Pending Changes</Button>}
                    {item.service.terms && item.service.terms.in_contract &&
                        <Button size={"small"}>{t('in_contract')}</Button>}

                    {item.service.trial_period && item.service.trial_period.trial_state === "IN_TRIAL" &&
                        <Button size={"small"}>{t('in_trial')}</Button>}
                </Grid>
                <Grid item container className={classes.sub_date}>
                    {item.service.terms && item.service.terms.auto_renew &&
                        <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                            <ReNewIcon />
                            <Grid item style={{ paddingLeft: 10 }}>
                                <Typography variant='subtitle2'>{t('auto_renew')}</Typography>
                                <Typography variant='body2'>{item.service.terms.contract_period && item.service.terms.contract_period.end_date ? formatDateToDDMMYYYYFrEpoch(item.service.terms.contract_period.end_date) : ''}</Typography>
                            </Grid>
                        </Grid>
                    }
                    {item.service.terms.in_contract
                        && item.service.terms.contract_period
                        && item.service.terms.contract_period.start_date
                        && item.service.terms.contract_period.end_date &&
                        <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <DateRangeBlackIcon />
                                <Grid item style={{ paddingLeft: 10 }}>
                                    <Typography variant='subtitle2'> {t('sub_contract_period') + " "} </Typography>
                                    <Typography variant='body2'>{formatDateToDDMMYYYYFrEpoch(item.service.terms.contract_period.start_date)} - {formatDateToDDMMYYYYFrEpoch(item.service.terms.contract_period.end_date)}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    }
                    {item.service.trial_period
                        && item.service.trial_period.end_date
                        && item.service.trial_period.start_date &&
                        <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <DateRangeBlackIcon />
                                <Grid item style={{ paddingLeft: 10 }}>
                                    <Typography variant='subtitle2'>{t('sub_trial_period')}</Typography>
                                    <Typography variant='body2'>{formatDateToDDMMYYYYFrEpoch(item.service.trial_period.start_date)} - {formatDateToDDMMYYYYFrEpoch(item.service.trial_period.end_date)}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    }
                </Grid>

                <Grid item xs={12} container justifyContent='center' alignItems='center'>
                    <Grid item xs={12}>
                        {item.service.added_on && <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <Typography variant='subtitle2'>{t('added_on')}:</Typography>
                                <Typography variant='body2'>{formatDateToDDMMYYYYFrEpoch(item.service.added_on)}</Typography>
                            </Grid>
                        </Grid>}
                        {item.service.removed_on && <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <Typography variant='subtitle2'>{t('removed_on')}:</Typography>
                                <Typography variant='body2'>{formatDateToDDMMYYYYFrEpoch(item.service.removed_on)}</Typography>
                            </Grid>
                        </Grid>}
                        {item.service.firts_activated_on && <Grid item xs={12}>
                            <Grid item xs={12} style={{ display: 'flex', alignItems: "center" }} >
                                <Typography variant='subtitle2'>{t('firts_activated_on')}:</Typography>
                                <Typography variant='body2'>{formatDateToDDMMYYYYFrEpoch(item.service.firts_activated_on)}</Typography>
                            </Grid>
                        </Grid>}
                    </Grid>
                    {(!isOpenserveContact && !isMetrofibreContact) && item.service.life_cycle_state === 'EFFECTIVE' && <Grid item xs={12}>
                        <Grid item xs={12} textAlign={'right'}>
                            <Button variant='contained' size='small'
                                className={classes.button}
                                onClick={() => props.onSwarpService(item)}
                                startIcon={<SortIcon />}
                            >
                                {t('btn_upgrade_downgrade')}
                            </Button>
                            {showTerminate && <Button variant='contained' size='small'
                                className={classes.button}
                                onClick={() => props.onTerminate(item)}
                                startIcon={<SortIcon />}
                            >
                                {t('btn_terminate')}
                            </Button>}
                           {showChangeBillingDay && <Button variant='contained' size='small'
                                className={classes.button}
                                onClick={() => props.onChangeBillingDay(item)}
                            >
                                {t('btn_change_billing_day')}
                            </Button>}
                        </Grid>
                    </Grid>}
                    {(isOpenserveContact || isMetrofibreContact) && item.service.life_cycle_state === 'EFFECTIVE' &&<Grid item xs={12}>
                        <Grid item xs={12} textAlign={'right'}>
                            <Button variant='contained' size='small'
                                className={classes.button}
                                onClick={() => props.onSwarpService(item)}
                                startIcon={<SortIcon />}
                            >
                                {t('btn_upgrade_downgrade')}
                            </Button>
                            {isOpenserveContact&&
                            <Button variant='contained' size='small'
                                className={classes.button}
                                onClick={() => props.onCancel(item)}
                                startIcon={<SortIcon />}
                            >
                                {t('btn_cancel')}
                            </Button>}
                        </Grid>
                    </Grid>}
                </Grid>
            </Grid>
        </Grid>
    );
}
